import { NuxtAppOptions } from '@nuxt/types';
import getAliasByLocale from '@root/common/utils/getAliasByLocale';

interface MobileAPI extends Window {
  MobileAPI: {
    toggleNavigation: () => void;
    toggleArchive: () => void;
  };
}

declare let window: MobileAPI;

// Used in Elisa Raamat
// In Elisa Raamat portal header is hidden, these functions help
// the user to navigate around in their app

export default ({ app }: { app: NuxtAppOptions }) => {
  window.MobileAPI = window.MobileAPI || {};
  window.MobileAPI.toggleNavigation = () => {
    const store = app.store;

    if (store) {
      const isOpen = store.getters['navigation/getHeaderAction']('issueList');
      store.commit('navigation/setHeaderAction', { type: 'issueList', value: !isOpen });
    }
  };

  window.MobileAPI.toggleArchive = () => {
    const path = getAliasByLocale(app.$channelConfig('settings').locale, 'issues');
    window.location.href = `/${path}`;
  };
};
